import React from 'react'
import { Box, ButtonPrimary, Flex } from '../../../components'
import Label from '../../../components/common/form/label/Label'
import { t, Trans } from '@lingui/macro'
import Input from '../../../components/common/form/input/Input'
import { useInputMaskingToggle } from '../useInputMaskingToggle'
import { useLoginContext } from '../login/LoginContext'
import IconArrowRight from '../../../components/common/icon/IconArrowRight'
import Form from '../../../components/common/form/Form'
import { WelcomeMessage } from '../login/components/WelcomeMessage'
import { OauthLoginButtons } from '../components/OauthLoginButtons'
import { SignToDifferentTeamLink } from '../login/components/SignToDifferentTeamLink'
import { observer } from 'mobx-react'
import { useAsyncCallback } from '../useAsyncCallback'
import validations from 'shared/validations'
import { notification } from '../../../components/common/notifications/Notifications'

type LoginStepSetPasswordProps = {
  submit(): Promise<void>
}

export const LoginStepSetPassword: React.FC<LoginStepSetPasswordProps> =
  observer(({ submit }) => {
    const { isAccountNameLoginOn, setPassword, userIdentity, password } =
      useLoginContext()
    const { isUnmasked, eyeButton } = useInputMaskingToggle()

    const [handleSubmit, pending] = useAsyncCallback(async () => {
      if (
        !userIdentity ||
        !password ||
        !password.match(validations.passwordRegex)
      ) {
        return notification.warning(t`Please insert valid password`)
      }
      await submit()
    })

    return (
      <Form onSubmit={handleSubmit}>
        <WelcomeMessage />

        <Flex justifyContent="space-between">
          <Label htmlFor="inputPassword">
            <Trans>Set a password for your new account.</Trans>
          </Label>
          {eyeButton}
        </Flex>
        <Box className="form-row">
          <input
            type={isAccountNameLoginOn ? 'text' : 'email'}
            id="inputEmail"
            autoComplete={isAccountNameLoginOn ? 'username' : 'email'}
            style={{
              display: 'none' // this input is here just to get rid of chrome warning and improve accessibility https://stackoverflow.com/a/48736294/671457
            }}
          />
          <Input
            type={isUnmasked ? 'text' : 'password'}
            id="inputPassword"
            placeholder={t`Password`}
            autoComplete="current-password"
            autoFocus
            fullWidth
            required
            onChange={setPassword}
          />
        </Box>

        <Box className="form-row">
          <ButtonPrimary
            type="submit"
            disabled={pending}
            isLoading={pending}
            isFullWidth
            rightIcon={<IconArrowRight />}
          >
            <span className="btn__text">
              <Trans>Sign up</Trans>
            </span>
          </ButtonPrimary>
        </Box>

        <OauthLoginButtons />
        <SignToDifferentTeamLink />
      </Form>
    )
  })

LoginStepSetPassword.displayName = 'LoginStepSetPassword'
